import { stripeKey } from "@/config";

let Stripe;
if (typeof window !== "undefined") {
  Stripe = window.Stripe;
  Stripe.setPublishableKey(stripeKey);
}

if (!Stripe) {
  console.error("failed to load Stripe.js");
}

export default Stripe;
export const cardType = (val = "") => Stripe.card.cardType(val);
